import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { designationById, updateDesignation } from '../../../actions/utilitiesAction'
import Add from '../../../component/Utilities/Designation/AddDesignation'
import constant from '../../../constant'

const AddDesignation = () => {

    const navigate = useNavigate()
    const params = useParams()
    const [response, setResponse] = React.useState({})
    const [showMsg, setShowMsg] = React.useState(false)
    const [data, setData] = useState(null)

    useEffect(() => {
        designationById(params.id).then((res) => {
            if (res.status) {
                setData(res.result)
            }
            else {
                setResponse(res)
                setShowMsg(true)
                setTimeout(() => {
                    setShowMsg(false)
                }, 7000)

            }
        }).catch(err => {
            alert(err)
        })
    }, [])
    const onSubmit = (model) => {
        updateDesignation(model).then((res) => {
            if (res.status) {
                navigate(constant.component.designationlist.url + '?p=' + model.pageno)
            }
            else {
                setResponse(res)
                setShowMsg(true)
                setTimeout(() => {
                    setShowMsg(false)
                }, 7000)
            }
        }).catch((err) => {
            alert(err)
        })
    }

    return (
        <React.Fragment>
            {data && <Add onSubmit={onSubmit} detail={data} response={response} showMsg={showMsg} />}
        </React.Fragment>
    )
}

export default AddDesignation